import { combineReducers } from 'redux';
import nameReducer from './Name/slice';
import citizenshipReducer from './Citizenship/slice';
import pastFillingsReducer from './PastFillings/slice';
import familyReducer from './Family/slice';
import dependentsReducer from './Dependents/slice';
import covidReliefReducer from './CovidRelief/slice';
import logisticsReducer from './Logistics/slice';

export default combineReducers({
  name: nameReducer,
  citizenship: citizenshipReducer,
  past_fillings: pastFillingsReducer,
  family: familyReducer,
  dependents: dependentsReducer,
  covidRelief: covidReliefReducer,
  logistics: logisticsReducer,
});
